import { xSequentialFillFromStep } from "./xSequentialFillFromStep.js";
export function xSequentialFillFromTo(parameters, options = {}) {
    const { from, to, size } = parameters;
    const step = (to - from) / (size - 1);
    return xSequentialFillFromStep({ from, step, size }, options);
}
//# sourceMappingURL=xSequentialFillFromTo.js.map